import { ethers } from 'ethers';
import TokenAbi from '../contracts/abis/Token.json';
import { Chain } from 'src/types/enums';

export const labelToId = (label: string): any => {
  const labelBytes = ethers.toUtf8Bytes(label);
  const labelHash = ethers.keccak256(labelBytes);
  const id = ethers.toBigInt(labelHash);
  return id;
};

export const isValidAddress = (address: string, chain: Chain): boolean => {
  if (chain === Chain.C) {
    return ethers.isAddress(address);
  }
  return false;
};

export const getTokenDetails = async (
  tokenAddress: string,
  basePrice: string,
  provider: ethers.Provider,
): Promise<Token> => {
  if (tokenAddress === '0x0000000000000000000000000000000000000000') {
    return {
      tokenAddress: tokenAddress,
      basePrice: Number(ethers.formatEther(basePrice)),
      name: 'Ether',
      symbol: 'ETH',
    };
  }
  const tokenContract = new ethers.Contract(tokenAddress, TokenAbi, provider);

  const name = await tokenContract.name();
  const symbol = await tokenContract.symbol();

  const token: Token = {
    tokenAddress: tokenAddress,
    basePrice: Number(ethers.formatEther(basePrice)),
    name: name,
    symbol: symbol,
  };

  return token;
};

export const getDomainHash = (parent: string, label: string): string => {
  const labelhash = ethers.keccak256(ethers.toUtf8Bytes(label));

  const abiCoder = ethers.AbiCoder.defaultAbiCoder();

  const domainHash = ethers.keccak256(
    abiCoder.encode(['bytes32', 'bytes32'], [parent, labelhash]),
  );

  return domainHash;
};

export const validateInput = (input: string): boolean => {
  // Allow empty input (deleting all characters)
  if (input === '') return true;

  // Regular expression to match the allowed characters and structure
  const regex = /^(?!-)(?!.*--)[a-z0-9-]+$/;

  // Test the input against the regular expression
  return regex.test(input);
};

export const getLevel1Subdomains = (
  domain: DomainTree,
): { name: string; owner: string }[] => {
  if (!domain.subdomains || domain.subdomains.length === 0) {
    return [];
  }

  return domain.subdomains.map(subdomain => ({
    name: subdomain.name,
    owner: subdomain.owner,
  }));
};
